export const getTextbooksData = (state) => state.textbooks.textbooks;
export const getLoadingStatus = (state) => state.textbooks.loadingStatus;
export const getSavingStatus = (state) => state.textbooks.savingStatus;
export const getErrorMessage = (state) => state.textbooks.errorMessage;
export const getCurrentTextbookId = (state) => state.textbooks.currentTextbookId;
